import axios from 'axios'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL

// Get one specific thing, based on its id
export const fetchOneThing = async (idThing) => {
    const response = await axios.get(`${apiUrl}/stuff/${idThing}`, {
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true, // Inclut les cookies dans la requête
    })
    return response.data
}

// Get all the things created by ONE user
export const fetchSomeoneStuff = async (userId) => {
    const response = await axios.get(`${apiUrl}/stuff/user/${userId}`)
    console.log(response)
    return response.data
}

// Get all the things created by THE user
export const fetchMyStuff = async () => {
    const response = await axios.get(`${apiUrl}/stuff/currentUser/myStuff`, {
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true, // Inclut les cookies dans la requête
    })
    return response.data
}

// Get all the stuff
export const fetchAllStuff = async () => {
    const response = await axios.get(`${apiUrl}/stuff/`)

    return response.data
}

// Get all the things created
export const fetchPeopleStuff = async ({ filters, page, resultsPerPage }) => {
    const response = await axios.get(`${apiUrl}/stuff/all/filtered/`, {
        params: {
            filters: filters,
            page: page,
            resultsPerPage: resultsPerPage,
        },
    })
    return response.data
}

// Sell the thing
export const sellThing = async (idThing, buyerId) => {
    const response = await axios.post(
        `${apiUrl}/stuff/${idThing}`,
        {
            buyerId,
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
            withCredentials: true, // Inclut les cookies dans la requête
        }
    )
    return response.data
}
